import * as req from '@/utils/request'
import station from '@/utils/station'
export class VueGlobal {
  constructor () {
    this.name = 'VueGlobal'
    // 用户详情
    this.dataList = []
    this.user_info = {}
    this.optionsList = []
    this.getBookData = []
    this.optionsList2 = []
    this.video = []
    // // 学习记录
    // this.bookData = []
    // this.loginURL = 'http://192.168.12.248:8080/#/'
    this.loginURL = 'http://www.xmhgapi.com/train_login'
    this.iconUrl = 'http://www.xmhgapi.com/train_userImg/'
    // 导出界面标识
    this.dialogVisible = false
    // 导出列表
    this.exportList = []
    this.total = 0
    this.stationList = station.stationData
  }
  stringToJson (data) {
    if (typeof data === 'string') {
      try {
        const obj = JSON.parse(data)
        if (typeof obj === 'object' && obj) {
          return obj
        } else {
          return {}
        }
      } catch (e) {
        return {}
      }
    }
    return {}
  }
  findData (name = '', id_number = '', size = 10, page = 1, startTime = '', endTime = '') {
    let sendData = {}
    sendData.data = {
      size: size,
      page: page,
      name: name,
      id_number: id_number,
      startTime: startTime,
      endTime: endTime
    }
    sendData.fn = this.findDataFn
    sendData.vm = this
    req.Post('certificate/get_all', sendData)
  }
  findDataFn (data) {
    debugger
    if (data === null) {
      this.$message.warning('查询失败！')
      return
    }
    if (data.code !== 0) {
      this.$message.warning('查询失败！')
      return
    }
    window.$global.exportList = data.data.data
    window.$global.total = data.data.total
    this.$message.success('查询成功！')
  }
  getName (list, id, objName) {
    for (let i in list) {
      if (list[i].id === id) {
        return list[i][objName]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/global/index.js